const { getElement, getElements } = window.BAO.Utils
class ModalElement extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['content']
  }

  connectedCallback () {
    super.connectedCallback()
    /* Remove the inline display: none */
    this.removeAttribute('style')
  }

  setupListeners () {
    this.open = this.open.bind(this)
    this.close = this.close.bind(this)

    document.addEventListener('keyup', event => {
      const keyCode = event?.code?.toUpperCase()
      if (keyCode === 'ESCAPE') {
        this.close(event, this.els?.close?.element)
      }
      const openTarget = document.activeElement.closest(
        this.modalTriggerSelector,
      )
      if (
        (keyCode === 'ENTER' ||
          keyCode === 'NUMPADENTER' ||
          keyCode === 'SPACE') &&
        openTarget
      ) {
        event.preventDefault()
        this.open(event, openTarget)
      }
    })

    this.listeners.add(document, 'click', this.handleGlobalClick.bind(this))
    this.listeners.add(this, 'click', this.handleContextClick.bind(this))

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.MODAL.LOCATION,
      this.showLocationModal,
    )
  }

  handleGlobalClick (event) {
    const triggerEl = event.target.closest(`[data-modal-trigger]`)
    if (!triggerEl) return
    this.open(event, triggerEl)
  }

  handleContextClick (event) {
    const modalEl = event.target.closest(this.localName)
    const contentEl = event.target.closest(this.els?.content?.selector)
    const contentNav = event.target.closest('[data-modal-navigation]')

    if (modalEl && !contentEl && !contentNav && this.dataset.autoclose !== 'true') {
      this.close(event, this.els?.close?.element)
    }

    const closeEl = event.target.closest(this.els?.close?.selector)
    if (closeEl) {
      this.close(event, closeEl)
    }
  }

  showLocationModal () {
    const trigger = getElement('[data-modal-trigger="store-selector"]')

    if (trigger) {
      trigger.click()
    }
  }

  open (event, target = event.target) {
    const triggerEl = target.closest(this.modalTriggerSelector)
    if (triggerEl.dataset.modalTrigger !== this.dataset.modal) return
    this.setCurrentModalFrame(triggerEl)
    this.setAttribute('aria-hidden', 'false')

    const currentFrameKey = triggerEl?.dataset?.modalElementFrameKey
    const currentFrameEl = this.frameEls.find(
      frameEl =>
        frameEl?.dataset?.modalElementFrameKey?.toString() ===
        currentFrameKey?.toString(),
    )
    if (!currentFrameEl) return

    const videoEl = getElement('video', { context: currentFrameEl })
    if (videoEl) {
      videoEl.play()
    }
  }

  close (event, target = event.target) {
    const closeEl = target.closest(this.els?.close?.selector)
    if (!closeEl) return
    this.setAttribute('aria-hidden', 'true')
    this.stopVideos()
  }

  stopVideos () {
    if (!this.videoEls.length) return
    this.videoEls.forEach(videoEl => {
      videoEl.pause()
      videoEl.currentTime = 0
    })
  }

  setCurrentModalFrame (triggerEl) {
    const currentFrameKey = triggerEl?.dataset?.modalElementFrameKey
    if (!currentFrameKey) return
    this.frameEls.forEach(frameEl => {
      frameEl.setAttribute(
        'aria-current',
        (
          frameEl?.dataset?.modalElementFrameKey.toString() ===
          currentFrameKey.toString()
        ).toString(),
      )
    })
  }

  get modalTriggerSelector () {
    return '[data-modal-trigger]'
  }

  get triggerEls () {
    return document.querySelectorAll(this.modalTriggerSelector)
  }

  get closeEls () {
    return this.els?.close?.elements || []
  }

  get frameEls () {
    return this.els?.frame?.elements || []
  }

  get videoEls () {
    return getElements('video', { context: this })
  }
}

if (!customElements.get('modal-element')) {
  customElements.define('modal-element', ModalElement)
}
